import { render } from "./ContactDetailPage.vue?vue&type=template&id=0e5d0dbc&ts=true"
import script from "./ContactDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/ContactDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e5d0dbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e5d0dbc', __exports__)) {
    api.reload('0e5d0dbc', __exports__)
  }
  
  module.hot.accept("./ContactDetailPage.vue?vue&type=template&id=0e5d0dbc&ts=true", () => {
    api.rerender('0e5d0dbc', render)
  })

}


export default __exports__